import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Title = styled.p`
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: 0.75rem;
`;

export const Row = styled.div`
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
`;

export const Desc = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
`;
